/* Copyright (c) 2020-2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { Link } from "react-router-dom";
import { FlexContainer } from "~/components";
import { ColumnProps } from "~/components/Tables/types";
import { ServiceTableItem } from "~/models/services";
import { ROUTES } from "~/routing";
import DeleteService from "./DeleteService";

export default function (
  canEdit: boolean,
  refetch: () => Promise<void>
): ColumnProps<ServiceTableItem>[] {
  const columns: ColumnProps<ServiceTableItem>[] = [
    {
      Header: "Service offering",
      accessor: "offeringName",
    },
    {
      Header: "Service name",
      accessor: "name",
      Cell: ({ row }) => {
        return (
          <Link to={`${ROUTES.services.index}/${row.original.id}`}>
            {row.original.name}
          </Link>
        );
      },
    },
    {
      Header: "Num of requests",
      accessor: "numRequests",
      center: true,
      Cell: ({ value }) => (
        <FlexContainer justify="center">{value}</FlexContainer>
      ),
    },
    {
      Header: "Num of commitments",
      accessor: "numCommitments",
      center: true,
      Cell: ({ value }) => (
        <FlexContainer justify="center">{value}</FlexContainer>
      ),
    },
  ];

  if (canEdit) {
    columns.push({
      Header: "Actions",
      accessor: "",
      width: "60px",
      Cell: ({ row }) => (
        <DeleteService service={row.original} refetch={refetch} />
      ),
    });
  }

  return columns;
}
